import React from 'react';
import { Route, BrowserRouter, Routes } from "react-router-dom";
import StickyNavbar from '../components/StickyNavbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import Home from '../pages/Home';
import List from '../pages/List';
import Icons from '../pages/Icons';
import Detail from '../pages/Detail';
import Login from '../pages/auth/Login';
import NotFound from '../pages/NotFound';

function Index() {
    return (
      <BrowserRouter>
        <ScrollToTop />
        <div className="flex min-h-screen flex-col">
          <StickyNavbar />
          <main className="flex-1">
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/login" element={<Login />} />
              <Route exact path="/icons" element={<Icons />} />
              <Route exact path="/list" element={<List />} />
              <Route exact path="/detail/:id" element={<Detail />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    );
}

export default Index;
